export const fail = msg => {
  throw new Error(msg);
};
